let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("48qi8")).then(() => parcelRequire('czs66'));